import { render, staticRenderFns } from "./GeoFenceRightSidebar.vue?vue&type=template&id=481253ba&scoped=true&"
import script from "./GeoFenceRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./GeoFenceRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./GeoFenceRightSidebar.vue?vue&type=style&index=0&id=481253ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481253ba",
  null
  
)

export default component.exports